/* eslint-disable prettier/prettier */
/* eslint-disable no-param-reassign */
/* eslint-disable react/jsx-props-no-spreading */
import React, { useState } from 'react';
import styled, { css } from 'styled-components';
import { useTranslation } from 'react-i18next';
import Checkbox from '@material-ui/core/Checkbox';
import axios from 'axios';

import { X, CheckboxCheckmark, EmptyCheckbox, GrayCheckMark } from '../../Constants/assets';

// Stylings
const InnerContainer = styled.div`
    position: absolute;
    z-index: 26;
    background: rgb(43, 44, 49);
    color: #ffffff;
    box-shadow: 0px 0px 24px rgba(0, 0, 0, 0.18);
    border-radius: 8px;  
`;
const CenterAllContainer = styled.div`
    width: 87%;
    height: 87%;
    display: flex;
    flex-direction: column;
    margin: 40px;
`;
const HeaderContainer = styled.div`
    margin-bottom:${(props) => (props.stage == 0 ? '30px' : '')};
    height: ${(props) => (props.stage == 0 ? '40%' : '70%')};
    display: flex;
    flex-direction: column;
`;
const ParagraphContainer = styled.div`
    height: min-content;
    font-size: 16px;
    font-weight: 400;
`;
const BodyContainer = styled.div`
    overflow-y: auto;
    font-size: 16px;
    margin-bottom: 25px;
`;

const Label = styled.label`
    margin-left: 0.5rem;
    display: flex;
    align-items: center;
    width: 100%;
    div {
        color: #81818c;
        padding-right: 10px;
    }
`;
const RadioBoxContainer = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 20px;
`;

const SecondLineHeader = styled.div`
    margin-bottom: ${(props) => (props.stage == 0 ? '15px' : '')};
    height: min-content;
    display: flex;
    flex-direction: column;
    text-align: left;
    color: #ffffff;
`;

const QuestionContainer = styled.div`
    font-weight: 400;
    font-size: 19px;
    line-height: 22px;
`;
const TitleContainer = styled.div`
    font-weight: bold;
    font-weight: 700;
    font-size: 24px;
    line-height: 26px;
`;
const ButtonContainer = styled.div`
    height: 50px;
    align-self: flex-end;
    display: flex;
    width: 216px;
`;
const ContinueButton = styled.button`
    width: 100%;
    background-color: #005857;
    border-radius: 4px;
    font-weight: 700;
    color: #ffffff;

    &:disabled {
        opacity: 0.5;
        cursor: 'context-menu';
    }
`;
const ButtonLayer = styled.div`
    display: flex;
    width: 94%;
    align-items: flex-end;
    justify-content: flex-end;
`;
const Button = styled.div`
    background: #005857;
    border-radius: 4px;
    height: 50px;
    width: 216px;
    cursor: pointer;
`;
const ButtonText = styled.div`
    font-weight: bold;
    font-size: 16px;
    line-height: 19px;
    color: #ffffff;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
`;
// const CardCheckbox = styled(Checkbox)`
//     /* && {
//         position: absolute;
//         right: 0;
//     } */
//     && {
//         height: 44px;
//     }
// `;
const CardCheckbox = styled.input`
    // /* && {
    //     position: absolute;
    //     right: 0;
    // } */
    // && {
    //     height: 44px;
    // }
`;

export default function Trivia({
    showTrivia,
    triviaToggle,
    data,
    playerId,
    gameId,
    triviaValues,
    endTurn,
    turnNeedsToEndInGate,
    turnEndsInGateToggle,
    walkingAlgorithm,
    playerStatus,
    startTurn,
    SoundPlay,
    soundForFlipAndCards,
    fetchConfig,
    isZoomed,
}) {
    const [selected, setSelected] = useState('');
    const [stage, setStage] = useState(0);
    const [checkedRadio, setCheckedRadio] = useState('');
    const [newPlayerStatus, setNewPlayerStatus] = useState(playerStatus);
    const { t } = useTranslation();

    const isItChecked = () => {
        if (checkedRadio == '') {
            return true;
        }
        return false;
    };
    const sendSelectionToServer = async () => {
        const baseUrl = `${fetchConfig.prefix}/game/user_answered_a_trivia_questions`;
        await axios
            .get(`${baseUrl}?gameId=${gameId}&userId=${playerId}&answer=${checkedRadio}&questionId=${triviaValues[triviaValues.length - 1].question_id}`,)
            .catch(error => console.log(error));
    };
    let feedbacksThreshold = false;
    if (triviaValues[triviaValues.length - 1]) {
        feedbacksThreshold = (triviaValues[triviaValues.length - 1].A + triviaValues[triviaValues.length - 1].B + triviaValues[triviaValues.length - 1].C + triviaValues[triviaValues.length - 1].D).length > 550;  // 550 is our threshold from which things start to break
    }
    const width = feedbacksThreshold && isZoomed ? '710px' : '610px';
    const headerWidth = feedbacksThreshold && isZoomed ? '600px' : '492px';
    if (!showTrivia) return null;
    const id = triviaValues[triviaValues.length - 1].question_id; 
    console.log("id:",triviaValues)
    return (
        <InnerContainer
            style={{
                width: stage == 0 ? width : '610px',
                height: stage == 0 ? 'auto' : '300px',
            }}
        >
            {stage == 0 && (
                <CenterAllContainer>
                    <HeaderContainer stage={stage}>
                        <SecondLineHeader stage={stage}>
                            <QuestionContainer>
                                <div>{t('modals.trivia.question')}</div>
                            </QuestionContainer>
                            <TitleContainer>
                                <div>{t(`modals.trivia.${id}.question_title`, { id})}</div>
                            </TitleContainer>
                        </SecondLineHeader>
                        <ParagraphContainer style={{ width: headerWidth }}>
                        {t(`modals.trivia.${id}.question_text`, { id})}
                        </ParagraphContainer>
                    </HeaderContainer>

                    <form style={{ display: 'grid' }}>
                        <BodyContainer>
                            <RadioBoxContainer>
                                <CardCheckbox
                                    onClick={() => {
                                        setCheckedRadio('A');
                                    }}
                                    name="action"
                                    type="radio"
                                />
                                <Label For="test">
                                    <div style={{ fontSize: '19px' }}>{t('modals.trivia.a')}</div>
                                    {t(`modals.trivia.${id}.answer1`, { id })}
                                </Label>
                            </RadioBoxContainer>
                            <RadioBoxContainer>
                                <CardCheckbox
                                    onClick={() => {
                                        setCheckedRadio('B');
                                    }}
                                    name="action"
                                    type="radio"
                                />
                                <Label For="test">
                                    <div style={{ fontSize: '19px' }}>{t('modals.trivia.b')}</div>{' '}
                                    {t(`modals.trivia.${id}.answer2`, { id})}
                                </Label>
                            </RadioBoxContainer>
                            <RadioBoxContainer>
                                <CardCheckbox
                                    onClick={() => {
                                        setCheckedRadio('C');
                                    }}
                                    name="action"
                                    type="radio"
                                />
                                <Label For="test">
                                    <div style={{ fontSize: '19px' }}>{t('modals.trivia.c')}</div>{' '}
                                    {t(`modals.trivia.${id}.answer3`, { id})}
                                </Label>
                            </RadioBoxContainer>
                            <RadioBoxContainer>
                                <CardCheckbox
                                    onClick={() => {
                                        setCheckedRadio('D');
                                    }}
                                    name="action"
                                    type="radio"
                                />
                                <Label For="test">
                                    <div style={{ fontSize: '19px' }}>{t('modals.trivia.d')}</div>{' '}
                                    {t(`modals.trivia.${id}.answer4`, { id})}
                                </Label>
                            </RadioBoxContainer>
                        </BodyContainer>
                        <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
                            <ButtonContainer>
                                <ContinueButton
                                    style={{
                                        cursor: isItChecked() ? 'context-menu' : 'pointer',
                                    }}
                                    type="submit"
                                    disabled={isItChecked()}
                                    onClick={() => setStage(1)}
                                >
                                    {t('modals.trivia.continue')}
                                </ContinueButton>
                            </ButtonContainer>
                        </div>
                    </form>
                </CenterAllContainer>
            )}
            {stage == 1 && (
                <div style={{ height: '100%' }}>
                    <HeaderContainer stage={stage}>
                        <div
                            style={{
                                display: 'grid',
                                alignItems: 'center',
                                margin: '40px',
                            }}
                        >
                            <SecondLineHeader stage={stage}>
                                <TitleContainer>
                                    <div style={{ fontSize: '24px', fontWeight: 'bold' }}>{t('modals.trivia.note')}</div>
                                </TitleContainer>
                            </SecondLineHeader>
                            {checkedRadio == 'A' && (
                                <ParagraphContainer style={{ fontSize: '16px' }}>
                                    {t(`modals.trivia.${id}.feedback1`, { id})}
                                </ParagraphContainer>
                            )}
                            {checkedRadio == 'B' && (
                                <ParagraphContainer style={{ fontSize: '16px' }}>
                                    {t(`modals.trivia.${id}.feedback2`, { id})}
                                </ParagraphContainer>
                            )}
                            {checkedRadio == 'C' && (
                                <ParagraphContainer style={{ fontSize: '16px' }}>
                                    {t(`modals.trivia.${id}.feedback3`, { id})}
                                </ParagraphContainer>
                            )}
                            {checkedRadio == 'D' && (
                                <ParagraphContainer style={{ fontSize: '16px' }}>
                                    {t(`modals.trivia.${id}.feedback4`, { id})}
                                </ParagraphContainer>
                            )}
                        </div>
                    </HeaderContainer>
                    <ButtonLayer
                        onClick={async () => {
                            triviaToggle(false);
                            setStage(0);
                            await sendSelectionToServer();
                            if (turnNeedsToEndInGate) {
                                endTurn();
                                SoundPlay(soundForFlipAndCards);
                            } else {
                                startTurn();
                                SoundPlay(soundForFlipAndCards);
                            }
                        }}
                    >
                        <Button>
                            <ButtonText> {t('modals.trivia.button1')}</ButtonText>
                        </Button>
                    </ButtonLayer>
                </div>
            )}
        </InnerContainer>
    );
}
